(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wici-header"]) return;
  try {
    
  (() => {
    const nav = document.querySelector('[data-wici-nav]');
    if (!nav) return;

    const toggle = nav.querySelector('[data-wici-toggle]');
    const panel = nav.querySelector('#wici-nav-mobile');
    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        toggle.classList.toggle('is-open', !open);
        panel.hidden = open;
      });
    }

    nav.querySelectorAll('[data-wici-group]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const sub = document.getElementById(btn.getAttribute('aria-controls'));
        if (!sub) return;
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        sub.hidden = open;
      });
    });

    const touch = window.matchMedia('(hover: none)');
    nav.querySelectorAll('[data-wici-drop]').forEach((drop) => {
      const btn = drop.querySelector('.wici-nav__drop-btn');
      if (!btn) return;
      btn.addEventListener('click', (event) => {
        if (touch.matches && !drop.classList.contains('is-open')) {
          event.preventDefault();
          drop.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
      document.addEventListener('click', (event) => {
        if (!drop.contains(event.target)) {
          drop.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });

    const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();
})();
